<template>
    <div>
        <card>
            <h2 style="color:#00467f;margin-top:10px;margin-left:5px;font-weight:bold;text-align:left">ANTIRICICLAGGIO - CARICA DOCUMENTO SOGGETTO</h2>
            <div class="form-row justify-content-center">
                <div class="form-group">
                    <h3 for="file" style="margin-bottom:20px">Carica documento personale</h3>
                    <button class="btn" style="margin-left:10px;font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file"></button><!-- v-on:change="checkFileUpload()" -->
                </div>
            </div>
           
            <!-- <div class="row justify-content-start" style="margin-top:10px;">
                <div class="col">
                <div v-if="cliente[0].ANTIRIC_CLIENTE_META.length > 0" style="margin-top:15px">
                    <p>File caricati:</p>
                    <div v-for="value in cliente[0].ANTIRIC_CLIENTE_META" v-bind:key="value.ID">
                        <p><a :href="'https://sviluppoallergeni.confcom.it'+  value.VALUE.url  + '?token='+access_token" target="_blank" style="color:black">{{value.VALUE.name}}</a></p>
                    </div>
                </div>
                <div v-else></div>
                </div>
                <div class="col"></div>
                <div class="col"></div>
            </div> -->
            <h3 style="margin-top:20px;color:#00467f">Identificazione<span style="color:#ff0000">*</span></h3>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="tipo_identificazione">Tipo identificazione</label>
                    <select v-model="tipo_identificazione" class="form-control">
                        <option value="Direttamente">Direttamente</option>
                        <option value="tramite atti">Tramite atti</option>
                        <option value="dic consolare">Dic. consolare</option>
                        <option value="altro profess">Altro profess.</option>
                        <option value="interm. abilitati">Interm. Abilitati</option>
                        <option value="altre modalità">Altre modalità</option>
                    </select>
                </div>
                <div class="form-group col-md-4">
                    <label for="data">Data<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data">
                </div>
                <div class="form-group col-md-4">
                    <label for="tipo_documento">Tipo Documento<span style="color:#ff0000">*</span></label>
                    <select v-model="tipo_documento" class="form-control">
                        <option value="carta identita">Carta d'identità</option>
                        <option value="patente">Patente</option>
                        <option value="passaporto">Passaporto</option>
                        <option value="porto d'armi">Porto d'armi</option>
                        <option value="tess. postale">Tess. postale</option>
                        <option value="altro">Altro</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="numero_documento">Numero Documento<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="numero_documento" placeholder="numero_documento">
                </div>
                <div class="form-group col-md-4">
                    <label for="data_scadenza">Data Scadenza<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_scadenza">
                </div>
                <div class="form-group col-md-4">
                    <label for="data_rilascio">Data Rilascio<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_rilascio">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="autorita_localita_rilascio">Autorità e località del rilascio<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="autorita_localita_rilascio">
                </div>
                <div class="form-group col-md-6">
                    <label for="tipo_documento">Dati acquisiti e verificati tramite<span style="color:#ff0000">*</span></label>
                    <select v-model="dati_acquisiti" class="form-control">
                        <option value="dichiarazione antiriciclaggio">Dichiarazione antiriciclaggio resa dal cliente x art. 22 D.Lgs 231/2007</option>
                        <option value="estratti pubblici registri">Estratti pubblici registri</option>
                        <option value="estratti elenchi">Estratti da elenchi, atti, documenti conoscibili da chiunque</option>
                    </select>
                </div>
            </div>
            <button type="button" class="btn float-right" style="background:#00467f" @click="handleFileUpload()">Salva</button>
        </card>
        
        <!--  MODAL CARICARE FILE -->
        <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal>
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import {Modal} from '@/components';
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';

export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            modals: {
                mini: false
            },
            file: null,
            showCheckFile: false,
            showLoader: false,
            cliente: null,

            // IDENTIFICAZIONE
            tipo_identificazione: null,
            numero_documento: null,
            autorita_localita_rilascio: null,
            data: null,
            data_scadenza: null,
            tipo_documento: null,
            data_rilascio: null,
            dati_acquisiti: null,

            //pop up per cercare 
            showRisultati: false,
            nessunRisulato: false,
            
            idCliente: null,
            idSoggetto: null,
            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'   //'https://apiintranet.confcom.it/'
        }
    },
    methods: {
        checkData: function() {
            if ( this.tipo_identificazione == null || this.numero_documento == null || this.autorita_localita_rilascio == null 
                || this.data == null || this.data_scadenza == null || this.tipo_documento == null || this.data_rilascio == null 
                || this.dati_acquisiti == null) {
                    return false;
                } else {
                    return true;
                }
        },
        checkFileUpload: function() {
            this.showCheckFile = true;
        },

         handleFileUpload: async function(){
            // this.showLoader = true;
            let token = localStorage.getItem('access_token');
            let risposta;
            let errore = 0;
            this.file = this.$refs.file.files[0];
            let formData = new FormData()
            formData.append('documento', this.file)
            /*
            IDENTIFICAZIONE ={
                IDENTIFICAZIONE_TIPO, IDENTIFICAZIONE_DATA, IDENTIFICAZIONE_TIPO_DOCUMENTO,
                IDENTIFICAZIONE_NUMERO_DOCUMENTO, IDENTIFICAZIONE_DATA_SCADENZA,
                IDENTIFICAZIONE_DATA_RILASCIO, IDENTIFICAZIONE_AUTORITA
                MODALITA_ACQUISIZIONE_DATI
            }
             */
            let identificazione = { IDENTIFICAZIONE: {
                IDENTIFICAZIONE_TIPO: this.tipo_identificazione, IDENTIFICAZIONE_NUMERO_DOCUMENTO: this.numero_documento, 
                IDENTIFICAZIONE_AUTORITA: this.autorita_localita_rilascio, 
                IDENTIFICAZIONE_DATA: this.data, IDENTIFICAZIONE_DATA_SCADENZA: this.data_scadenza, IDENTIFICAZIONE_TIPO_DOCUMENTO: this.tipo_documento, 
                IDENTIFICAZIONE_DATA_RILASCIO: this.data_rilascio, MODALITA_ACQUISIZIONE_DATI: this.dati_acquisiti}
            };
            console.log(identificazione);
            
            formData.append('IDENTIFICAZIONE', JSON.stringify(identificazione));
            await AntiriciclaggioServices.caricaDocumentoSoggetto(this.idCliente, this.idSoggetto, formData)
            .then(response => { risposta = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                console.log(`errore 401`);
                let value = await Services.refreshTokenFunction();
                if (value) { await this.handleFileUpload(); }
            }
            // this.showCheckFile = false;
            // this.showLoader = false;
            const url = '/anagrafica-soggetti?idCliente=' + this.idCliente;
            this.$router.push({
                path: url
            });
        },

        handleremoveFile: function(){
            this.file = null;
        },

        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            this.idCliente = this.$route.query.idCliente;
            console.log(`idCliente=${this.idCliente}.`);
            this.idSoggetto = this.$route.query.idSoggetto;
            this.access_token = localStorage.getItem('access_token');
            axios.defaults.withCredentials = true;
            try {
                // if (this.idCliente != null)
                //     await this.caricaCliente(this.idCliente);
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                if (error.response.status == 401) {
                await Services.refreshTokenFunction();
                }
            }
        }
    },

    mounted() {
        
    },
    beforeMount() {
        this.main();
    }
  };
</script>
<style scoped>
/* body {
    margin: 10px; 
     padding: 10px;
} */
form {
    /* max-width: 580px; */
    margin: auto;
}
label {
    font-size: 18px;
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
  padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

</style>
  